angular.module('core').filter('dynamic', function($filter) {
  // Receives one argument - another filter to be applied (passing arguments is also possible)
  // This way dynamic filter can be applied
  return function(value, filterName) {
      if (filterName !== undefined && filterName !== null) {
          try {
              var parts = filterName.split(':');
              var name = parts[0];
              if (name !== 'dynamic') {
                  if (parts.length > 1) {
                      return $filter(name)(value, parts.slice(1));
                  } else {
                      return $filter(name)(value);
                  }
              }
          } catch (e) {
              // we shouldn't break if filter is not found or parsing failed
              // just return the value
              return value;
          }
      }
      return value;
  };
});
